import React, { useEffect, useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { CFormLabel } from "@coreui/react";

import { useAuth } from "../contexts/AuthContext";
import { useFloor } from "../contexts/FloorContext";

function FloorSelection({
    value,
    onChange,
    className = "",
    labelClassName = "",
    multiSelect = true,
    required = false,
    error = false,
    placeholder = "Select floor...",
    label = "Floor",
    disabled = false
}) {
    const { restaurantId } = useAuth();
    const { getAllFloors } = useFloor();

    const [key, setKey] = useState(0);

    // Reset select when restaurant changes
    useEffect(() => {
        if (restaurantId) {
            setKey((prev) => prev + 1);
        }
    }, [restaurantId]);

    const loadFloors = async (searchValue) => {
        try {
            if (!restaurantId) {
                return { options: [] };
            }

            const response = await getAllFloors(searchValue);

            const options =
                response?.map((floor) => ({
                    label: floor.name,
                    value: floor.id,
                })) || [];

            return {
                options,
                hasMore: false, // pagination removed
            };
        } catch (err) {
            console.error("Error fetching floors", err);
            return {
                options: [],
                hasMore: false,
            };
        }
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            whiteSpace: state.isFocused ? 'pre-wrap' : 'nowrap',
            wordBreak: state.isFocused ? 'break-all' : null,
            wordWrap: state.isFocused ? 'break-word' : null,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }),
    };

    return (
        <div key={key} className={className}>
            {label && (
                <div className={labelClassName}>
                    <CFormLabel>
                        {label} {required && <span className="text-danger">*</span>}
                    </CFormLabel>
                </div>
            )}
            <div className='w-100'>
                <AsyncPaginate
                    className={`${error && required ? "multiSelect_error" : ""}`}
                    value={value}
                    loadOptions={loadFloors}
                    isMulti={multiSelect}
                    closeMenuOnSelect={!multiSelect ? true : false}
                    onChange={onChange}
                    isDisabled={disabled}
                    placeholder={placeholder}
                    noOptionsMessage={() => "No floors found"}
                    loadingMessage={() => "Loading floors..."}
                    SelectProps={{
                        isSearchable: true,
                    }}
                    menuShouldScrollIntoView={false}
                    menuPortalTarget={document.querySelector('body')}
                    styles={customStyles}
                />

                {error && required && (
                    <span className="text-danger error_message">
                        Please select at least one floor.
                    </span>
                )}
            </div>
        </div>
    );
}

export default FloorSelection;
